import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed top-0 left-0 flex justify-center items-center w-full h-full bg-modal z-50"
}
const _hoisted_2 = { class: "main-content mb-8" }
const _hoisted_3 = { class: "flex gap-4" }
const _hoisted_4 = { class: "title flex-auto" }
const _hoisted_5 = { class: "text-lg" }
const _hoisted_6 = { class: "add-widget flex-initial h-12" }
const _hoisted_7 = { class: "mt-6 rounded-lg shadow-default" }

import { ref, onMounted, watch } from "vue";
import axios from "axios";
import WidgetCard from "../components/WidgetCard.vue";
import AddWidgetModal from '../components/modals/AddWidgetModal.vue';
import AddWidgetBtn from "../components/buttons/AddWidgetBtn.vue";
import ToastPopup from "../components/notifications/ToastPopup.vue";
import { WidgetI } from "../interfaces/interfaces";
import { changeCase } from "../helpers";
import { ElementE } from '../enums';


export default /*#__PURE__*/_defineComponent({
  __name: 'WidgetView',
  setup(__props) {

const widgets = ref<WidgetI[]>([]);
const isError = ref<boolean>(false);
const errorMessage = ref<string>('');
const deletedWidgetTitle = ref<string>('');
const showDeleteWidgetToast = ref<boolean>(false);
const showErrorToast = ref<boolean>(false);
const showAddWidgetButton = ref<boolean>(true);
const isAddWidgetModalVisible = ref<boolean>(false);

const handleWidgetDelete = (id: number | string, title: string) => {
  widgets.value = widgets.value.filter(widget => widget.id !== id);

  showDeleteWidgetToast.value = true;
  deletedWidgetTitle.value = title;
}

onMounted(async() => {
  const token = sessionStorage.getItem("TOKEN");
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  try {
    const { data } = await axios.get(`${process.env.VUE_APP_API}v3/get-widgets`, config);
    widgets.value = data.sort((a: { name: string; }, b: { name: string; }) => a.name.localeCompare(b.name));
  } catch (error) {
    console.error(error);
    errorMessage.value = 'Widgets are not found';
    isError.value = true;
  }
});

watch(() => isError.value, (value: boolean) => {
  if (value) {
    showErrorToast.value = true;

    setTimeout(() => {
      isError.value = false;
      showErrorToast.value = false;
    }, 5000);
  }
});

watch(() => [showDeleteWidgetToast.value, showErrorToast.value], ([newValueOne, newValueTwo]) => {
  if (newValueOne) {
    setTimeout(() => {
      showDeleteWidgetToast.value = false;
    }, 3000);
  }

  if (newValueOne || newValueTwo) {
    showAddWidgetButton.value = false;
    return;
  }
  showAddWidgetButton.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isAddWidgetModalVisible.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(AddWidgetModal, {
            onClose: _cache[0] || (_cache[0] = ($event: any) => (isAddWidgetModalVisible.value = false))
          })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h1", _hoisted_5, _toDisplayString(_unref(changeCase)('my widgets', _unref(ElementE).TITLE)), 1)
        ]),
        (showErrorToast.value)
          ? (_openBlock(), _createBlock(ToastPopup, {
              key: 0,
              status: "error",
              text: errorMessage.value,
              onClose: _cache[1] || (_cache[1] = ($event: any) => (showErrorToast.value = false))
            }, null, 8, ["text"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          (showAddWidgetButton.value || widgets.value === undefined)
            ? (_openBlock(), _createBlock(AddWidgetBtn, {
                key: 0,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (isAddWidgetModalVisible.value = true))
              }))
            : _createCommentVNode("", true)
        ]),
        (showDeleteWidgetToast.value)
          ? (_openBlock(), _createBlock(ToastPopup, {
              key: 1,
              status: "success",
              text: `"${deletedWidgetTitle.value}" has been deleted`,
              width: 300,
              onClose: _cache[3] || (_cache[3] = ($event: any) => (showDeleteWidgetToast.value = false))
            }, null, 8, ["text"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(widgets.value, (item, i) => {
          return (_openBlock(), _createBlock(WidgetCard, {
            key: item.id,
            id: item.id,
            title: item.name,
            widget_id: item.id,
            widget_description: item.description,
            "is-first": i === 0,
            "is-last": i === widgets.value.length - 1,
            onDeleted: handleWidgetDelete
          }, null, 8, ["id", "title", "widget_id", "widget_description", "is-first", "is-last"]))
        }), 128))
      ])
    ])
  ], 64))
}
}

})